import "admin/src/style/videoMetadataPage.css";
import { DeleteModal } from "features/videoUploads/DeleteModal";
import { RenameVideoButton } from "features/videoUploads/RenameVideoButton";
import { fileNotReadyReason, isFileReady, isVideoDeleted } from "features/videoUploads/functions";
import { _ } from "i18n";
import client from "libs/client";
import { useState } from "react";
import Modal from "ui-kit/src/Modal";

interface AdminGameVideoUploadActionsProps {
	videoUploadId: number;
}

export function AdminGameVideoUploadActions({ videoUploadId }: AdminGameVideoUploadActionsProps) {
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [hasBeenDeleted, setHasBeenDeleted] = useState(false);
	const { data: videoResponse, isLoading } = client.getVideo.useQuery(
		{ id: videoUploadId },
		{ queryKey: ["metadataVideos", "gamePageVideo", videoUploadId] }
	);
	const video = videoResponse?.data;

	if (isLoading) {
		return (
			<div className="adminOptionsItem">
				<div className="adminOptionsItem-label">{_("admin.video.gamePage.videoActions")}</div>
				<div>{_("admin.video.info.loadingGame")}</div>
			</div>
		);
	}

	if (video == null || hasBeenDeleted || isVideoDeleted(video)) {
		return null;
	}

	const canShowDelete = video.metadataApprovedAt == null;
	const fileReady = isFileReady(video.apiStatus);
	const canDelete = canShowDelete && fileReady;

	return (
		<div className="adminOptionsItem adminGameVideoUploadActions">
			<div className="adminOptionsItem-label">{_("admin.video.gamePage.videoActions")}</div>
			<div className="adminGameVideoUploadActions-buttons">
				<RenameVideoButton
					videoId={video.id}
					currentName={video.name}
					className="adminOptionsItem-button"
					label={_("admin.video.actions.editName")}
				/>
				{canShowDelete ? (
					<button
						type="button"
						className="adminOptionsItem-button"
						onClick={() => setShowDeleteModal(true)}
						disabled={fileReady === false}
						title={fileReady === false ? fileNotReadyReason(video.apiStatus) : undefined}
					>
						{_("admin.video.actions.delete")}
					</button>
				) : null}
			</div>
			{canDelete ? (
				<Modal show={showDeleteModal} onClose={() => setShowDeleteModal(false)} size="sm" title={_("admin.video.actions.delete")}>
					<DeleteModal videoId={video.id} close={() => setShowDeleteModal(false)} onDeleted={() => setHasBeenDeleted(true)} />
				</Modal>
			) : null}
		</div>
	);
}
